import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { HA_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { toNewQueryValue } from '@doda/common/src/logics/createJobSearchRequestParams';
import { ACCETABLE_LOWER_LIMIT_INCOME_VALUES } from '@doda/common/src/constants/accetableRequestValues';
import { LowerLimitIncomeRequestCode } from '@doda/api-client/aspida/@types';

/**
 * 年収下限のAPIリクエスト作成
 * @param queryParams クエリパラメータ
 * @returns 年収下限のAPIリクエスト
 */
export const createLowerLimitIncomeApiRequest = (
  queryParams: AppQueryParams
) => {
  let lowerLimitIncomeName = '';
  let ha = '';

  if (queryParams.ha) [ha] = queryParams.ha;
  const findHa = HA_SEARCH_ITEMS.find((option) => option.id === ha);
  if (findHa) {
    lowerLimitIncomeName = findHa.seoText;
  } else {
    // マスタに存在する値かの判定
    throw new Error('パラメータの不正(ha)');
  }
  const requestLowerLimitIncomeId = toNewQueryValue(
    ha,
    ACCETABLE_LOWER_LIMIT_INCOME_VALUES
  ) as LowerLimitIncomeRequestCode | undefined;

  return { lowerLimitIncomeName, requestLowerLimitIncomeId };
};
